import { userPermissionsActions } from '../../reducers/userPermissions/userPermissions';
import { getRequest, patchRequest } from '../../../shared/axiosRequest';
import { API_PATHS } from '../../../shared/apiConsts';

const EPC_ROLE = 'EPC USER';

export const REQUESTS_CONSTS = {
  SUCCESS_MESSAGE:
    'Request has been sent successfully, approval might take up to 24h. A notification mail with approval decision will be sent',
  FAILURE_MESSAGE: 'Request has not been sent',
  LIST_RESOURCES: 'Resources',
  REQUESTS_LIST_DATA: {
    REQUESTEE: 'requestee',
    USERNAME: 'userName',
    DISPLAYNAME: 'displayName',
    REGEX_PATTERN: '(?<==).*?(?=,)',
  },
};

export const getUserPermissions = userName => {
  return async dispatch => {
    try {
      const response = await getRequest(API_PATHS.GET_USER_ROLES + userName);
      dispatch(userPermissionsActions.setUserPermissions(response));
    } catch (error) {
      console.error(error);
    }
  };
};

export const requestEPCPermission = (wwid, justification, role = 'USER') => {
  return async dispatch => {
    try {
      const response = await patchRequest(API_PATHS.PATCH_USER_ROLE, {
        RoleType: role,
        justification,
        wwid,
      });
      dispatch(userPermissionsActions.setPermissionRequestStatus(true));
    } catch (error) {
      console.error(error);
    }
  };
};

export const checkPendingRequests = userName => {
  return async dispatch => {
    try {
      const res = await getRequest(API_PATHS.GET_LIST_AGS_REQUESTS);
      try {
        for (const request of res[REQUESTS_CONSTS.LIST_RESOURCES]) {
          if (isRequestIsEPCUsersOfUser(request, userName)) {
            dispatch(userPermissionsActions.setPermissionRequestStatus(true));
            return;
          }
        }
      } catch {
        dispatch(userPermissionsActions.setPermissionRequestStatus(false));
      }
    } catch (error) {
      console.error(error);
    }
  };
};

const isRequestIsEPCUsersOfUser = (request, userName) => {
  return (
    request[REQUESTS_CONSTS.REQUESTS_LIST_DATA.REQUESTEE][
      REQUESTS_CONSTS.REQUESTS_LIST_DATA.USERNAME
    ] === userName &&
    request[REQUESTS_CONSTS.REQUESTS_LIST_DATA.DISPLAYNAME] == EPC_ROLE
  );
};
